var _defs, _rect, _rect2, _rect3, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack187({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 1,
    y: 6.75,
    width: 14,
    height: 2.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 7.02,
    y: 2.5,
    width: 1.96,
    height: 11,
    transform: "translate(16 0) rotate(90)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 7.46,
    y: 5,
    width: 1.07,
    height: 6,
    transform: "translate(16 0) rotate(90)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 1,
    y1: 6.75,
    x2: 15,
    y2: 9.25
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 15,
    y1: 6.75,
    x2: 1,
    y2: 9.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack187);
export default __webpack_public_path__ + "static/media/Symbolpack_1_87.da7ab97ba3824248f53e40c61d233e1d.svg";
export { ForwardRef as ReactComponent };